module.exports = __webpack_public_path__ + "img/Icon3D.ed481877.png";